import React from 'react';
import './Projects.scss';

const Projects: React.FC = () => {
  const projects = [
    { id: 1, title: 'विहीर दुरुस्ती व पाणीपुरवठा सुधारणा', desc: 'ग्रामीण पाणी पुरवठा सुधारण्यासाठी दुरुस्ती व देखभाल.' },
    { id: 2, title: 'ग्रामस्वच्छता उपक्रम', desc: 'स्वच्छता अभियान अंतर्गत कचरा व्यवस्थापन सुधारणा.' },
    { id: 3, title: 'रस्ता दुरुस्ती', desc: 'मुख्य रस्त्यांची देखभाल व डांबरीकरण.' },
  ];

  return (
    <div className="projects">
      <section className="page-hero">
        <div className="container">
          <h1>ग्रामविकास प्रकल्प</h1>
          <p className="subtitle">ग्रामातील सुरू असलेले व पूर्ण झालेले प्रकल्प</p>
        </div>
      </section>
      {/* <div className="breadcrumb-bar">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>ग्रामविकास प्रकल्प</span>
          </nav>
        </div>
      </div> */}

      <section className="container content">
        <h2>चालू व पूर्ण प्रकल्प</h2>
        <p>
          तांडा ग्रामपंचायत मार्फत ग्रामविकासासाठी विविध प्रकल्प राबविले जातात. खालील यादीत पाणीपुरवठा,
          स्वच्छता, रस्ता दुरुस्ती इत्यादी महत्त्वाच्या प्रकल्पांची माहिती दिली आहे. नागरिकांनी या
          प्रकल्पांविषयी माहिती ठेवून सहकार्य करणे अपेक्षित आहे.
        </p>
        <div className="grid">
          {projects.map(p => (
            <article key={p.id} className="card">
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="container content">
        <h2>प्रकल्पांचे प्रकार</h2>
        <div className="grid">
          <div className="card">
            <h3>पायाभूत सुविधा प्रकल्प</h3>
            <p>
              रस्ते दुरुस्ती व बांधकाम, गटारे व जलनिस्सारण व्यवस्था, सार्वजनिक प्रकाश व्यवस्था, शासकीय
              इमारतींची दुरुस्ती व सुशोभीकरण.
            </p>
          </div>
          <div className="card">
            <h3>पाणीपुरवठा व स्वच्छता</h3>
            <p>
              विहिरी व बोअरवेल दुरुस्ती, नळयोजना सुधारणा, घरगुती नळजोडणी वाढविणे, घनकचरा व्यवस्थापन व
              ग्रामस्वच्छता अभियान अंतर्गत कामे.
            </p>
          </div>
          <div className="card">
            <h3>शिक्षण व सामाजिक विकास</h3>
            <p>
              शाळा दुरुस्ती, अंगणवाडी सुधारणा, ग्रंथालय व अभ्यासिका, महिला बचत गट व युवक मंडळांना
              प्रोत्साहन देणारे उपक्रम.
            </p>
          </div>
        </div>
      </section>

      <section className="container content">
        <h2>प्रकल्प राबविण्याची पद्धत</h2>
        <div className="grid">
          <div className="card">
            <h3>योजना व आराखडा</h3>
            <p>
              ग्रामसभेत नागरिकांच्या गरजा मांडल्या जातात. त्या आधारे प्राथमिकता ठरवून तांत्रिक व आर्थिक
              आराखडा तयार केला जातो आणि संबंधित योजनेतून निधीची मागणी केली जाते.
            </p>
          </div>
          <div className="card">
            <h3>कामकाज व देखरेख</h3>
            <p>
              काम सुरू होण्यापूर्वी अंदाजित खर्च व कालावधी निश्चित केला जातो. कामादरम्यान ग्रामपंचायत
              सदस्य, नागरीक प्रतिनिधी व संबंधित विभाग यांच्या देखरेखीखाली कामे पूर्ण केली जातात.
            </p>
          </div>
          <div className="card">
            <h3>हिशोब व अहवाल</h3>
            <p>
              प्रकल्प पूर्ण झाल्यानंतर खर्चाचा तपशील, देयकांची नोंद व कामाचा अहवाल ग्रामपंचायत कार्यालयात
              उपलब्ध करून दिला जातो आणि तो ग्रामसभेत सादर केला जातो.
            </p>
          </div>
        </div>
      </section>

      <section className="container content">
        <h2>नागरिकांचा सहभाग</h2>
        <p>
          ग्रामविकास प्रकल्प यशस्वी होण्यासाठी ग्रामस्थांचा सक्रिय सहभाग अत्यंत महत्त्वाचा आहे. सुचना,
          तक्रारी किंवा नवीन प्रकल्पांबाबतचे प्रस्ताव ग्रामसभेत किंवा ग्रामपंचायत कार्यालयात लेखी स्वरूपात
          देता येतात.
        </p>
        <div className="grid">
          <div className="card">
            <h3>सुचना व प्रस्ताव</h3>
            <p>
              गावातील गरजांनुसार नवीन प्रकल्प सुचविणे, विद्यमान प्रकल्पांवरील अनुभव सांगणे आणि आवश्यक
              बदलांविषयी सूचना देणे.
            </p>
          </div>
          <div className="card">
            <h3>स्वयंप्रेरित कामे</h3>
            <p>
              श्रमदान, वृक्षारोपण, स्वच्छता मोहीम, पाणीसाठा संवर्धन यांसारख्या उपक्रमांमध्ये स्वयंप्रेरणेने
              सहभागी होऊन प्रकल्पांची परिणामकारकता वाढविणे.
            </p>
          </div>
          <div className="card">
            <h3>पारदर्शकतेसाठी सहकार्य</h3>
            <p>
              आय-व्यय नोंदी पाहणे, अधिकृत माहितीची पुष्टी करणे व योग्य ठिकाणी प्रश्न विचारून
              प्रकल्पांबाबत पारदर्शकता राखण्यास मदत करणे.
            </p>
          </div>
        </div>
      </section>
      {/* <h1 style={{ marginTop: '100px' }}>This page is under development, please visit later...</h1> */}
    </div>
  );
};

export default Projects;
